var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-partner"},[_c('MoleculesPortfolioMoleculePartner',_vm._l((_vm.partnerData),function(partner,index){return _c('AtomsPortfolioAtomPartner',{key:index,attrs:{"image":_vm.resourceUrl(partner.image),"link":partner.link}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }